export type FileUsageType = 'resume' | 'profile_picture' | 'career_card' | 'other';
export type FileUsageContext = 'resume_upload' | 'profile_update' | 'card_generation' | 'other';

export interface FileUsage {
  type: FileUsageType;
  context: FileUsageContext;
}

export type FileSource = 'local' | 'google_drive' | 'linkedin';
export type ThumbnailStatus = 'pending' | 'generated' | 'failed';

export interface FileMetadata {
  id: string;
  user_id: string;
  file_name: string;
  file_path?: string;
  mime_type: string;
  size: number;
  usage: FileUsage;
  source: FileSource;
  source_metadata?: Record<string, unknown>;
  thumbnail_url?: string;
  thumbnail_status?: ThumbnailStatus;
  thumbnail_generated_at?: string;
  external_file_id?: string;
  external_web_url?: string;
  external_download_url?: string;
  external_thumbnail_url?: string;
  external_thumbnail_status?: 'pending' | 'generated' | 'failed';
  external_thumbnail_generated_at?: string;
  access_token?: string;
  created_at: string;
  updated_at: string;
  deleted_at?: string;
}

export interface StorageConfig {
  MAX_FILE_SIZE: {
    admin: number;
    default: number;
  };
  ALLOWED_MIME_TYPES: {
    resumes: string[];
    images: string[];
  };
  THUMBNAIL: {
    maxWidth: number;
    maxHeight: number;
    quality: number;
  };
}

export const STORAGE_CONFIG: StorageConfig = {
  MAX_FILE_SIZE: {
    admin: 100 * 1024 * 1024, // 100MB for admin users
    default: 10 * 1024 * 1024, // 10MB for all other users
  },
  ALLOWED_MIME_TYPES: {
    resumes: [
      'application/pdf',
      'application/msword',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
    ],
    images: [
      'image/jpeg',
      'image/png',
      'image/webp'
    ]
  },
  THUMBNAIL: {
    maxWidth: 300,
    maxHeight: 300,
    quality: 80
  }
};

export class FileServiceError extends Error {
  constructor(message: string, public cause?: Error) {
    super(message);
    this.name = 'FileServiceError';
  }
}

export class QuotaExceededError extends FileServiceError {
  constructor(message: string, public quotaInfo: {
    used_bytes: number;
    total_bytes: number;
    available_bytes: number;
  }) {
    super(message);
    this.name = 'QuotaExceededError';
  }
}

export class ThumbnailGenerationError extends FileServiceError {
  constructor(message: string, public fileName: string) {
    super(message);
    this.name = 'ThumbnailGenerationError';
  }
} 